import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function Select({
  label,
  options,
  onChange,
  className,
  value,
  disabled,
  required = false,
  isCategory = false,
  setInstitucija,
  setLokacija,
}) {
  options.sort((a, b) => {
    let fa = a.label.toLowerCase(),
      fb = b.label.toLowerCase();

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });

  return (
    <div
      className={cleanJoin(
        "select ",
        className,
        required && !disabled && +value === 0 ? "is-danger" : ""
      )}
      style={{ width: "100%", marginLeft: "0%", marginRight: "0%" }}
    >
      {disabled ? (
        <select style={{ width: "100%" }} disabled>
          <option defaultValue value="">
            {label}
          </option>
        </select>
      ) : (
        <select
          onChange={(e) => {
            setLokacija && setLokacija("");
            setInstitucija && setInstitucija("");
            onChange(e.target.value);
          }}
          value={value}
          style={{ width: "100%" }}
        >
          <option defaultValue value={isCategory ? "0" : ""}>
            {/*kada se odabere default value da mogu ocistit state */}
            {label}
          </option>
          {options.map((item, index) => {
            return <option key={"opt" + index} value={item.value} label={item.label} />;
          })}
        </select>
      )}
    </div>
  );
}

export default Select;
